import React, { useState } from "react";
import Modal from "../common/Modal/Modal";
import MHeader from "./common/MHeader";
import MFooter from "./common/MFooter";
import { ReactComponent as CloseIcon } from "./../../resources/images/icons/modalCloseIcon.svg";
// import CustomSnackbar from "../common/Snackbar/CustomSnackbar";
import { toast } from "react-toastify";

interface Props {
  isOpen: boolean;
  setIsOpen: Function;
  searchValue?: string;
  id?: number | null;
}

const CopyLinkModal = ({ isOpen, setIsOpen, searchValue, id }: Props) => {
  // const [snackbarOpen, setSnackbarOpen] = useState(false);
  // const [isError, setIsError] = useState(false);
  // const link = `${window.location.origin}/edge/foldermanagement?folderID=${id}&autoMatch=false`;
  const domain_origin = window.location.origin.replace("recruiter.","www.");
  const link = `${domain_origin}/seeker/job-details?kId=${id}`;

  const handleClose = () => {
    setIsOpen(false);
  };

  // const handleSnackbarClose = () => {
  //   setSnackbarOpen(false);
  // };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        // setSnackbarOpen(true);
        // setIsError(false);
        toast.success("Copied to clipboard", {
          autoClose: 5000,
          position: "bottom-left",
          toastId: "success-toast-custom",
        });
        handleClose();
      })
      .catch(() => {
        // setSnackbarOpen(true);
        // setIsError(true);
        toast.error("Error Copying job!", {
          autoClose: 5000,
          position: "bottom-left",
        });
      });
  };

  const Header = (
    <MHeader>
      <span className="mjp-modal-text-header">Copy Link</span>
    </MHeader>
  );

  const Footer = (
    <MFooter>
      <div className="discard-draft-footer">
        <div style={{ width: "48%" }}>
          <button
            className="foundit-button primaryButton medium full-width"
            onClick={handleCopy}
          >
            Copy
          </button>
        </div>
      </div>
    </MFooter>
  );

  return (
    <React.Fragment>
      <Modal
        modalId="mjp-modal-discard-draft"
        isOpen={isOpen}
        onClose={handleClose}
        header={Header}
        footer={Footer}
        closeIcon={<CloseIcon />}
        width="500px"
      >
        <div className="mjp-modal-body discard-draft-body">
          <input
            type="text"
            style={{
              padding: "16px",
              border: "1px solid #D2D1D6",
              borderRadius: "8px",
              width: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            value={link}
            readOnly
          />
        </div>
      </Modal>

      {/* <CustomSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={isError ? "Error Copying job!" : "Copied to clipboard"}
        variant={isError ? "error" : "success"}
      /> */}
    </React.Fragment>
  );
};

export default CopyLinkModal;
